'use strict';

var bodyStateDetection = require('body-state-detection');
var imageProportion = require('image-proportion');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var slideshowUtils = require('./slideshow-utils');

var viewportMap = {
	small: {
		slideshowImageSize: 'large'
	},
	medium: {
		slideshowImageSize: 'large'
	},
	large: {
		slideshowImageSize: 'xlarge'
	},
	xlarge: {
		slideshowImageSize: 'xlarge'
	},
	xxlarge: {
		slideshowImageSize: 'xlarge'
	}
};

var getUrl = function(imageSize, data) {

	return 'url(' + dataMgr.getImageUrl(imageSize, { imageIndex: data.index }) + ')';

};

var getImageSize = function() {

	var deviceSize = bodyStateDetection.getState();
	var imageSize = viewportMap[deviceSize].slideshowImageSize;

	return imageSize;

};

// Accepts an image data index and returns an array including the previous and
// next indexes, if they exist.
var getTargetIndexes = function(index) {

	var indexes = [index];

	if (!slideshowUtils.isFirstImage(index)) {

		// There is a previous image.
		indexes.unshift(index - 1);

	}

	if (!slideshowUtils.isLastImage(index, dataMgr.getGalleryData())) {

		// There is a next image.
		indexes.push(index + 1);

	}

	return indexes;

};

var sizeWatermark = function($watermark, watermarkMeta, imgWidth, imgHeight) {

	// We want the watermark to scale based on the size of the image. The image
	// is sized and positioned via css, so we'll use JS to determine it's
	// scaled size.

	var scaledImage = imageProportion.contain(imgWidth, imgHeight, appDom.window.width(), appDom.window.height());
	var scaledWatermark = imageProportion.contain(watermarkMeta.width, watermarkMeta.height, scaledImage.width, scaledImage.height);

	$watermark.css({
		width: scaledWatermark.width,
		height: scaledWatermark.height
	});

};

var resizeWatermark = function(targetIndex, $cells) {

	// Resize any watermark images based on the new window and image size.
	getTargetIndexes(targetIndex).forEach(function(idx) {

		var $cell = $cells.eq(idx);
		var imgData = dataMgr.getImageMeta(idx);

		sizeWatermark($cell.find('.slideshow__watermark'), dataMgr.getWatermarkMeta(), imgData.width, imgData.height);

	});

};

var removeImage = function($cell) {

	$cell
		.css('background-image', 'none')
		.empty();

};

var removeImages = function($cells, targetIndex) {

	if (targetIndex - 2 >= 0) {

		removeImage($cells.eq(targetIndex - 2));

	}

	if (targetIndex + 2 < dataMgr.getGalleryData().length) {

		removeImage($cells.eq(targetIndex + 2));

	}

};

var loadImages = function(targetIndex, $cells, opts) {

	var imageSize = getImageSize();
	var targetIndexes = getTargetIndexes(targetIndex);
	var hasWatermarkEnabled = dataMgr.hasWatermarkEnabled();

	opts = opts || {};

	targetIndexes.forEach(function(idx) {

		var imgData = dataMgr.getImageMeta(idx);
		var $cell = $cells.eq(idx);
		var curBg = $cell.css('background-image');
		var newBg = getUrl(imageSize, imgData);
		var watermarkMeta;
		var $watermark;

		// If enabled, setup watermark
		if (hasWatermarkEnabled) {

			watermarkMeta = dataMgr.getWatermarkMeta();
			$watermark = $('<img class="slideshow__watermark" src="' + watermarkMeta.url + '">');
			sizeWatermark($watermark, watermarkMeta, imgData.width, imgData.height);

		}

		$cell.css('max-height', imgData.height);

		// Only add if necessary, avoids flicker on mobile.
		if (curBg !== newBg && (curBg === 'none' || opts.force)) {

			$cell.css('background-image', newBg);

			if (hasWatermarkEnabled) {

				$cell.html($watermark);

			}

		}

	});

};

module.exports = {
	loadImages: loadImages,
	removeImages: removeImages,
	resizeWatermark: resizeWatermark
};
